import {OvereasProcessor} from "./src/OvereasProcessor";

let slpPay = new OvereasProcessor(window as any, jQuery);
(window as any).slpPayments = slpPay;
